import { Component, input } from '@angular/core';

import { NgxBadgeModule } from '@digipay/ngx-badge';
import { StatusBarComponent } from '../status-bar/status-bar.component';
import { CrowdFundingModel } from '../../models/crowd-funding.model';
import { IranianRialsPipe } from '../../../../../../../../../apps/website/src/app/ui/ui-pipes/iranian-rials.pipe';

@Component({
  selector: 'app-project-status-detail',
  templateUrl: './project-status-detail.component.html',
  styleUrls: ['./project-status-detail.component.scss'],
  standalone: true,
  imports: [NgxBadgeModule, StatusBarComponent, IranianRialsPipe],
})
export class ProjectStatusDetailComponent {
  crowd = input<CrowdFundingModel>();
}
